var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items && _vm.items.length > 0
    ? _c(
        "div",
        { staticClass: "list-jewels" },
        [
          _c("div", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t(_vm.section.toLowerCase())))])
          ]),
          _c(
            "swiper",
            {
              ref: "mySwiper",
              staticClass: "swiper",
              attrs: { options: _vm.swiperOptions }
            },
            [
              _vm._l(_vm.items, function(item) {
                return _c(
                  "div",
                  {
                    key: item.sku,
                    staticClass: "swiper-slide cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.selectJewel(item)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "w-100 parent-img" }, [
                      _c("img", {
                        staticClass: "border-img",
                        attrs: { src: _vm.baseImageUrl + item.image }
                      }),
                      item && item.minPrice
                        ? _c("span", { staticClass: "jewel-name" }, [
                            _vm._v(" " + _vm._s(item.name) + " "),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.minPrice.toFixed(2).replace(".", ",")
                                ) +
                                "€ "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              }),
              _c("div", {
                staticClass: "swiper-button-prev",
                attrs: { slot: "button-prev" },
                slot: "button-prev"
              }),
              _c("div", {
                staticClass: "swiper-button-next",
                attrs: { slot: "button-next" },
                slot: "button-next"
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }